import { render, staticRenderFns } from "./EnvSelectorDialogReleases.vue?vue&type=template&id=47b58fdf&scoped=true&"
import script from "./EnvSelectorDialogReleases.vue?vue&type=script&lang=js&"
export * from "./EnvSelectorDialogReleases.vue?vue&type=script&lang=js&"
import style0 from "./EnvSelectorDialogReleases.vue?vue&type=style&index=0&id=47b58fdf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b58fdf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDialog,VSelect,VTextField})
